import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import {
  getSummaryValue,
  makeExpEstRow,
  makeExpEstHeaders,
  getTitle,
  buildDisplayText,
  makeModelTables,
} from '../utils'

const summaryMapper = (item) => {
  const estimatedValue = getSummaryValue(item?.predicted, 'Half-Life')

  const halfLife = buildDisplayText({ mainText: 'Half-Life', mainTextClass: 'font-weight-bold' })

  return {
    values: [estimatedValue],
    tables: [
      {
        headers: makeExpEstHeaders(),
        rows: [makeExpEstRow(item?.experimental, item?.predicted, halfLife)],
      },
    ],
    notes: item?.predicted?.model?.notes ?? null,
  }
}

const descriptorsMapper = (item) => {
  const models = (item?.predicted?.model?.models ?? []).map(({ type, ...model }) => ({
    ...model,
    name: type,
  }))

  return {
    tables: makeModelTables(models),
  }
}

const atmosphericHalfLife = (items) => {
  const item = items?.find((i) => i?.property === 'atmosphericHalfLife')
  const meta = findEpiSuiteGroupById('atmosphericHalfLife')

  return {
    title: getTitle(meta),
    description: meta?.description,
    helpPage: meta?.helpPage,
    summary: summaryMapper(item),
    modelDescriptors: descriptorsMapper(item),
    modelOutput: item?.predicted?.model?.output ?? null,
  }
}

export { atmosphericHalfLife }
